import { combineReducers } from 'redux';
import auth from './auth';
import param from './param';

export default combineReducers({
  auth,
  param
});
